import React from 'react';
import Base from 'client/components/base';
import StringStore from 'client/stores/strings';

export default class GetApp extends Base {
  constructor() {
    super();
  }

  render() {
    let view = this.props && this.props.view ? this.props.view : 'home';

    return (
      <section id="getapp" className={this.css()}>
        <div className="content">
          <div className="get-app-puff copy-content">
            <h1>{StringStore.get(`${view}.getApp.title`)}</h1>
            <p>{StringStore.get(`${view}.getApp.body`)}</p>
            <div className="button-container">
              <a
                href="https://itunes.apple.com/app/acast-podcast-player/id925311796"
                target="_blank"
              >
                <img
                  className="button-app-store"
                  src="https://cdn.acast.com/images/icons/icon-app-store.svg"
                />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.acast.nativeapp"
                target="_blank"
              >
                <img
                  className="button-google-play"
                  src="https://cdn.acast.com/images/icons/icon-google-play-2.png"
                />
              </a>
              <a
                href="https://www.microsoft.com/en-us/store/p/acast/9nblggh4np8f"
                target="_blank"
              >
                <img
                  className="button-microsoft-store"
                  src="https://cdn.acast.com/images/icons/icon-microsoft-store.png"
                />
              </a>
            </div>
          </div>
          <div className="get-app-image" />
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./client/components/landing/get-app/get-app.es6